import login from './login';

export default {
  language: 'tr-TR',
  country: 'tr',
  name: 'Türkçe',
  embeddedLocale: login,
};
